import React from "react"
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'
import clearProps from '../../utils/clearProps';

export default class Footer extends React.Component {
  constructor(props) {
    super(props)

    this.config = {
      types : [
        {
          title: 'default',
          isDefault: true,
        },
        'secondary'
      ],
      modifiers : [],
      states : []
    }

  }
  
  renderIcons(social) { 
    if(!social) return
    const socialList = social.map((icon, index) => 
      <li key={index} className="mdn-Footer-list-item">
        <a href={icon.href} {...icon.props}>
          <span className={`mdn-Icon-${icon.icon} mdn-Icon--md`}></span>
        </a>
      </li>
    )
    return socialList
  }


  render() {
    const { children, data, secondary, ...rest } = this.props
    let dataFooter = data || {}
    const props = clearProps(this.props)
    return <footer {...rest} className={resolveProps(this.props, this.config, 'Footer')} role="contentinfo">
    <div className="mdn-Container">
      <div className="mdn-Footer-content">
        <img className="mdn-Footer-logo" src={dataFooter.imageSrc || `https://mondrian.claro.com.br/brands/${secondary ?'default' :'inverse'}/claro.svg`} alt={dataFooter.imageAlt || `Logo da Claro`} />
        <p className="mdn-Footer-disclaimer">
          {children}
        </p>
        {dataFooter.social ? 
          <ul className="mdn-Footer-list">
            {this.renderIcons(dataFooter.social)}
          </ul>
        : null}
      </div>
    </div>
  </footer>
  
  }
}

Footer.propTypes = {
  children : PropTypes.node,
  secondary : PropTypes.bool,
  data : PropTypes.object
}